// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"920144e1","350":"87fec742","361":"0f65147a","632":"33491f76","676":"87fec742"}[chunkId] + ".chunk.css";
};